import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import type { IBrandInCitationsOverview } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/types";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const useBrandInCitations = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<IBrandInCitationsOverview> =>
    useLLMReportQuery<IBrandInCitationsOverview, ILLMWidgetRequestParams>(
        "brandInCitations",
        apiClient.AiTracker.aiTrackerReportsSourceAnalysisReportBrandInCitationsList,
        params,
        options,
    );
